import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useModalsContext } from "@/contexts/ModalsContext";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

export default function CarouselItemFirstAdd({ item }) {
  const { openModal } = useModalsContext();
  const { user, isAuthenticated } = useSelector((state) => state.auth);

  return (
    <div
      key={item.id}
      className={`min-w-full h-full relative flex items-center justify-center overflow-hidden transition-transform duration-300 ease-in-out border-2 border-aw-green rounded-lg`}
    >
      {/* Imagen de fondo */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${item.backgroundSrc})` }}
      />

      <div className="grid h-full w-full bg-black/10 backdrop-blur-[0.5px]">
        {/* Contenido del slide */}
        <div className="flex flex-col items-start justify-between pt-4 sm:pt-0 sm:justify-center relative z-10 text-left select-none text-white px-8 2xl:px-16">
          {item.verified && (
            <span className="text-sm md:text-lg font-semibold mb-1 animate-fade-in leading-3">
              <FontAwesomeIcon
                icon="fa-solid fa-check-circle"
                className="mr-2 text-sky-500 bg-white rounded-full"
              />
              Administra, gestiona y vende tickets
            </span>
          )}
          <h2 className="text-2xl md:text-5xl font-bold sm:my-2 animate-fade-in leading-tight">
            {item.title}
          </h2>
          <div className="flex flex-col w-full gap-x-4">
            <p className="block text-xs md:hidden line-clamp-1 mb-2 opacity-90 animate-slide-up ">
              {item.subTitleXs}
            </p>
            <p className="hidden md:block text-md line-clamp-1 opacity-90 animate-slide-up ">
              {item.subTitle}
            </p>
            <div className="flex items-center w-full gap-x-4">
              {isAuthenticated && user.perEmbajador == 0 && (
                <Link
                  to={`/perfil/${user.uid}/activar-embajador`}
                  className="sm:hidden text-xs sm:text-base bg-aw-green text-aw-bluedark font-semibold px-3 sm:px-6 py-3 rounded-3xl hover:bg-aw-green-dark transition duration-300 scale-100 hover:scale-95"
                >
                  SER EMBAJADOR
                </Link>
              )}
              {isAuthenticated && (
                <Link
                  to={`/empresa/crear`}
                  className="sm:hidden text-xs sm:text-base bg-aw-green text-aw-bluedark font-semibold px-3 sm:px-6 py-3 rounded-3xl hover:bg-aw-green-dark transition duration-300 scale-100 hover:scale-95"
                >
                  CREAR EMPRESA
                </Link>
              )}
              {!isAuthenticated && (
                <button
                  onClick={() => openModal("register")}
                  className="sm:hidden text-xs sm:text-base bg-aw-green text-aw-bluedark font-semibold px-3 sm:px-6 py-3 rounded-3xl hover:bg-aw-green-dark transition duration-300 scale-100 hover:scale-95"
                >
                  QUIERO UNIRME
                </button>
              )}
            </div>
          </div>
          <div
            className={`flex items-center justify-center gap-x-2 sm:mt-4 animate-fade-in`}
          >
            {/* <button className="bg-aw-blue text-white px-3 sm:px-6 py-3 text-xs sm:text-base border rounded-3xl hover:bg-aw-blue-dark transition duration-300 scale-100 hover:scale-95">
              Proximamente
              *-* Play store & App Store icons *-*
              <FontAwesomeIcon
                icon="fa-brands fa-google-play"
                className="ml-2 text-md"
              />
              <FontAwesomeIcon
                icon="fa-brands fa-apple"
                className="ml-2 text-lg"
              />
              </button> */}

            {/* Desktop */}
            {isAuthenticated && user.perEmbajador == 0 && (
              <Link
                to={`/perfil/${user.uid}/activar-embajador`}
                className="hidden sm:block text-xs sm:text-base bg-aw-green text-aw-bluedark font-semibold px-3 sm:px-6 py-3 rounded-3xl hover:bg-aw-green-dark transition duration-300 scale-100 hover:scale-95"
              >
                SER EMBAJADOR
              </Link>
            )}
            {isAuthenticated && (
              <Link
                to={`/empresa/crear`}
                className="hidden sm:block text-xs sm:text-base bg-aw-green text-aw-bluedark font-semibold px-3 sm:px-6 py-3 rounded-3xl hover:bg-aw-green-dark transition duration-300 scale-100 hover:scale-95"
              >
                CREAR EMPRESA
              </Link>
            )}
            {!isAuthenticated && (
              <button
                onClick={() => openModal("register")}
                className="hidden sm:block text-xs sm:text-base bg-aw-green text-aw-bluedark font-semibold px-3 sm:px-6 py-3 rounded-3xl hover:bg-aw-green-dark transition duration-300 scale-100 hover:scale-95"
              >
                QUIERO FORMAR PARTE DEL CLUB DE APPWHOOP TICKET
              </button>
            )}
            {item.recentAmbassadors && item.recentAmbassadors.length > 0 && (
              <div className="hidden sm:flex items-center -space-x-2.5 overflow-hidden">
                {item.recentAmbassadors.map((ambassador, index) => (
                  <img
                    key={index}
                    src={ambassador.image}
                    alt={ambassador.name}
                    className="w-8 h-8 sm:w-12 sm:h-12 rounded-full object-cover border-2 border-white shadow-md"
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
